import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Languages, Sparkles } from "lucide-react";

/**
 * Auto-translates `text` to the user's UI language when different.
 * Shows a small "Translated by AI · Show original" toggle.
 */
export default function TranslatedText({ text, className = "", as: As = "p", testid = "translated-text" }) {
  const { lang } = useI18n();
  const [translated, setTranslated] = useState(null);
  const [showOriginal, setShowOriginal] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setTranslated(null);
    setShowOriginal(false);
    if (!text || lang === "en") return;
    setBusy(true);
    api.post("/translate", { text, target_lang: lang })
      .then(r => {
        if (r.data?.text && r.data.text.trim() !== text.trim()) setTranslated(r.data.text);
      })
      .catch(() => {})
      .finally(()=>setBusy(false));
  }, [text, lang]);

  if (!text) return null;
  if (!translated) {
    return <As className={className} data-testid={testid}>{text}</As>;
  }
  return (
    <div data-testid={testid}>
      <As className={className}>{showOriginal ? text : translated}</As>
      <button type="button" onClick={()=>setShowOriginal(!showOriginal)}
        className="mt-3 inline-flex items-center gap-1.5 text-xs text-[#4A4A4A] hover:text-[#0A0A0A]"
        data-testid={`${testid}-toggle`}>
        {busy ? <Sparkles size={12} className="animate-pulse"/> : <Languages size={12}/>}
        {showOriginal ? "Show translated" : "Translated by AI · Show original"}
      </button>
    </div>
  );
}
